import { render } from "./DatasetProgress.vue?vue&type=template&id=46c576b0"
import script from "./DatasetProgress.vue?vue&type=script&lang=js"
export * from "./DatasetProgress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__